import Throttle from "lodash.throttle";

// GLOBAL VARS -------------------------

const tabsComponentBp = 720;

// ELEMENTARY --------------------------

const elementary = require("./vendor/elementary.js");

window.addEventListener("load", elementary, false);
window.addEventListener("resize", Throttle(elementary, 100), false);

// MODULES -----------------------------

import Forms from "./modules/forms";
Forms();

import NavTriggers from "./modules/nav-triggers";
NavTriggers();

import Videos from "./modules/videos";
Videos();

import Tabs from "./modules/tabs";
Tabs();

import TabsList from "./modules/tabs-list";
TabsList();

import TabPanels from "./modules/tab-panels";
TabPanels();

import TabsComponent from "./modules/tabs-component";
TabsComponent(tabsComponentBp);

import Carousels from "./modules/carousel";
Carousels();

import Galleries from "./modules/gallery";
Galleries();

import FilteredCarousels from "./modules/filtered-carousel";
FilteredCarousels();

import Filters from "./modules/filters";
Filters();

import EventsViewSwitcher from "./modules/events-view-switcher";
EventsViewSwitcher();

import { FilteredEventsList } from "./modules/filtered-events-list";
FilteredEventsList(siteBaseUrl);

import Modal from "./modules/modal";
Modal();

const validation = require("bluegg-validation");
const Nav = require("bluegg-nav");

const chosenDateClose = document.querySelector("[data-chosen-date-close]");

if (chosenDateClose !== null) {
	chosenDateClose.addEventListener("click", function () {
		// Create custom event to pass up
		const chosenDateClosedEvent = new CustomEvent("chosen-date-closed", {
			bubbles: true,
		});

		chosenDateClose.dispatchEvent(chosenDateClosedEvent);
	});
}

// var mainNav = new Nav({
// 	nav: '.nav--primary',
// 	trigger: '#primary-nav-trigger'
// });

// var validation = new Validation({
// 	errorClass: 'form__row--error',
// 	fieldContainer: '.form__row'
// });

// FONT LOADING
// if (!document.documentElement.classList.contains('fonts-loaded')) {
// 	var fontA = new FontFaceObserver('helvetica', {
// 		weight: 'normal',
// 		style: 'normal'
// 	});
// 	var fontB = new FontFaceObserver('helvetica', {
// 		weight: 'normal',
// 		style: 'italic'
// 	});
// 	var fontC = new FontFaceObserver('helvetica', {
// 		weight: 'bold',
// 		style: 'normal'
// 	});
//
// 	Promise.all([fontA.load(), fontB.load(), fontC.load()]).then(function() {
// 		document.documentElement.className += ' fonts-loaded';
// 		createCookie('fonts-loaded', true);
// 	});
// }
// }

// SCROLLING EVENTS -----------------------

let currScrollPos = 0;

function checkScrollPos() {
	htmlEl.classList.toggle("is-scrolled", window.scrollY > 20);
	htmlEl.classList.toggle("scrolling-up", window.scrollY < currScrollPos && window.scrollY > 0);
	currScrollPos = window.scrollY;
}

window.addEventListener("scroll", Throttle(checkScrollPos, 100));
checkScrollPos();

import GdprBanner from "./modules/gdpr-banner";
GdprBanner();

import MapView from "./modules/map-view";
MapView();
